export default __webpack_public_path__ + "static/media/underdog_devs.581895bb.webp";